import { useAppActions } from 'reducers/slices/uploadFileSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { uploadFileToS3, uploadProfileImageToS3, uploadCompanyLogoToS3 } = useAppActions();
  const {
    videoUploadingStatus,
    uploadProgress,
    profileImageUploadingStatus,
    companyLogoImageUploadingStatus,
  } = useSelector(state => state.uploadFileSlice);

  return {
    uploadFileToS3,
    isVideoUploading: useFetchStatus(videoUploadingStatus).isPending,
    uploadProgress,
    uploadProfileImageToS3,
    uploadCompanyLogoToS3,
    uploadingProfileImage: useFetchStatus(profileImageUploadingStatus).isPending,
    uploadingCompanyLogoImage: useFetchStatus(companyLogoImageUploadingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useUploadFile.js